import { render, staticRenderFns } from "./guideDetails.vue?vue&type=template&id=3c003a79&scoped=true"
import script from "./guideDetails.vue?vue&type=script&lang=js"
export * from "./guideDetails.vue?vue&type=script&lang=js"
import style0 from "./guideDetails.vue?vue&type=style&index=0&id=3c003a79&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c003a79",
  null
  
)

export default component.exports